// src/api/emailTemplateApi.js
import { API_URL } from '../config/apiConfig';

// Get all email templates for an affiliate
export const getEmailTemplates = async (affiliateId) => {
    try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/email-templates?affiliateId=${affiliateId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            throw new Error(`Error fetching templates: ${response.status} ${response.statusText}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('❌ Error fetching email templates:', error);
        throw error;
    }
};

// Create new email template
export const createEmailTemplate = async (templateData) => {
    try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/email-templates`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(templateData),
        });

        if (!response.ok) {
            throw new Error(`Error creating template: ${response.status} ${response.statusText}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('❌ Error creating email template:', error);
        throw error;
    }
};

// Update email template
export const updateEmailTemplate = async (templateId, templateData) => {
    try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/email-templates/${templateId}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(templateData),
        });

        if (!response.ok) {
            throw new Error(`Error updating template: ${response.status} ${response.statusText}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('❌ Error updating email template:', error);
        throw error;
    }
};

// Delete email template
export const deleteEmailTemplate = async (templateId) => {
    try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/email-templates/${templateId}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            throw new Error(`Error deleting template: ${response.status} ${response.statusText}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('❌ Error deleting email template:', error);
        throw error;
    }
};

